import { render } from "./ModalAddCustomerDomain.vue?vue&type=template&id=713872b1"
import script from "./ModalAddCustomerDomain.vue?vue&type=script&lang=js"
export * from "./ModalAddCustomerDomain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__